import { useHistory } from 'react-router-dom';
import userCourseHistoryApi from 'Api/axios/user-course-histories-api';
import useHistoryCoursesApi from 'Hooks/useHistoryCoursesApi';
import useTranslation from 'Hooks/useTranslation';
import { useState } from 'react';
import type { HistoryCoursesFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';

export const useHistoryCoursesReportPage = () => {
  const history = useHistory();
  const { t2 } = useTranslation('history_courses_report');
  const [currentFilters, setCurrentFilters] = useState<HistoryCoursesFilterI>({});

  const {
    data: historyCoursesData,
    meta: historyCoursesMeta,
    loading: historyCoursesLoading,
    error: historyCoursesError,
    fetchHistoryCourses,
  } = useHistoryCoursesApi({ init: true });

  const handleSearch = (filters: HistoryCoursesFilterI) => {
    setCurrentFilters(filters);
    fetchHistoryCourses({ ...filters, page: 1 });
  };

  const handlePageChange = (page: number) => {
    fetchHistoryCourses({ ...currentFilters, page });
  };

  const handleRowsPerPageChange = (limit: number) => {
    fetchHistoryCourses({ ...currentFilters, page: 1, limit });
  };

  const handleExport = async () => {
    const response = await userCourseHistoryApi.exportCoursesCollection(currentFilters);

    if (response.data) {
      downloadFile(response.data, `historial_cursos_reporte.xlsx`);
    }
  };

  const handleRowClick = (row: { id: string }) => {
    history.push(`/reporte/historial/cursos/${row.id}`);
  };

  return {
    historyCoursesData,
    historyCoursesMeta,
    historyCoursesLoading,
    historyCoursesError,
    fetchHistoryCourses,
    t2,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
    handleRowClick,
  };
};
